import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/providers/AuthProvider';

/**
 * Route guard for {@code /platform/**}. Distinct from
 * {@code ProtectedRoute} because it needs to send a logged-in *operator*
 * back to {@code /admin} (not {@code /}) when they try to access the
 * platform dashboard — an operator clicking a stale platform link from
 * their inbox shouldn't land on the marketing home, they should land
 * on their own admin.
 */
export default function PlatformAdminGuard() {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-dark">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  const roles = user?.roles ?? [];
  if (roles.includes('PLATFORM_ADMIN')) {
    return <Outlet />;
  }

  const isOperator = roles.some((r) => r === 'OPERATOR_ADMIN' || r === 'OPERATOR_STAFF');
  return <Navigate to={isOperator ? '/admin' : '/'} replace />;
}
